// Fechas de calendario ("YYYY-MM-DD") en la zona del navegador. Se manejan como
// texto a propósito: new Date("2026-11-30") se interpreta en UTC y en Colombia
// muestra el 29, y comparar textos en este formato ordena igual que las fechas.

/** Fecha de hoy en la zona del navegador, en el mismo formato que una columna DATE. */
export const hoyLocal = (fecha = new Date()) => {
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const dia = String(fecha.getDate()).padStart(2, "0");
  return `${fecha.getFullYear()}-${mes}-${dia}`;
};

/** "2026-10-31" + 1 -> "2026-11-01". Opera en UTC para que no lo mueva un cambio de hora. */
export const sumarDias = (fecha, dias) => {
  const [anio, mes, dia] = String(fecha).split("-").map(Number);
  const resultado = new Date(Date.UTC(anio, mes - 1, dia + dias));
  return resultado.toISOString().slice(0, 10);
};

export const fechaCorta = (valor) => {
  if (!valor) return "";
  const [anio, mes, dia] = String(valor).slice(0, 10).split("-");
  return anio && mes && dia ? `${dia}/${mes}/${anio}` : "";
};

/** "Hoy", "Mañana", "Ayer" o la fecha corta. */
export const fechaRelativa = (fecha, hoy = hoyLocal()) => {
  if (!fecha) return "";
  if (fecha === hoy) return "Hoy";
  if (fecha === sumarDias(hoy, 1)) return "Mañana";
  if (fecha === sumarDias(hoy, -1)) return "Ayer";
  return fechaCorta(fecha);
};

// Las DATETIME guardan la hora local del servidor de base de datos (GETDATE()) y la API
// las entrega como si fueran UTC ("2026-10-25T17:08:00Z" son las 17:08 de Bogotá). Se
// formatean en UTC para mostrar esa misma hora; en la zona del navegador saldrían corridas.
const FORMATO_FECHA_HORA = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };

/** "25/10/2026, 05:08 p. m." o "—" si no hay fecha válida. */
export const fechaHoraDelServidor = (valor, { segundos = false } = {}) => {
  if (!valor) return "—";
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "—";
  return fecha.toLocaleString("es-CO", { ...FORMATO_FECHA_HORA, ...(segundos ? { second: "2-digit" } : {}), timeZone: "UTC" });
};

/** Solo la hora si es de hoy (según el servidor), si no la fecha corta. Para listas de chats. */
export const fechaCompactaDelServidor = (valor, ahora = new Date()) => {
  if (!valor) return "";
  const fecha = new Date(valor);
  if (Number.isNaN(fecha.getTime())) return "";
  const dia = fecha.toISOString().slice(0, 10);
  if (dia === hoyLocal(ahora)) {
    return fecha.toLocaleTimeString("es-CO", { hour: "2-digit", minute: "2-digit", timeZone: "UTC" });
  }
  return fechaCorta(dia);
};
